import Vue from 'vue'
import Router from 'vue-router'
import Orders from './views/Orders.vue'
import Logout from './views/Logout.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'orders',
      component: Orders,
      meta: {
        requiresAuth: true,
        title: 'Benjamin Moore Inventory Portal - Orders'
      },      
      children: [{
        path: 'details/:order',
        name: 'orderDetails',
        component: () => import('./views/OrderDetail.vue'),
        meta: {
          requiresAuth: true,
          title: 'Benjamin Moore Inventory Portal - Orders'
        }
      }]
    },
    {
      path: '',
      name: 'admin',
      component: () => import('./views/Admin.vue'),
      meta: {
        requiresAuth: true,
        title: 'Benjamin Moore Inventory Portal - Admin'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
      meta: {
        requiresAuth: false,
        title: 'Benjamin Moore Inventory Portal - Login'
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
